module.exports = __webpack_public_path__ + "static/media/Calc_1.168b25dd.png";